import React from "react";
import ReactDOM from "react-dom";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";

const ShapeTooLong = ({ isOpen, onClose, title, description }) => {
  if (!isOpen) return null;

  const getContainer = () => {
    if (document.fullscreenElement instanceof HTMLElement) {
      return document.fullscreenElement;
    }
    return document.body;
  };

  const container = getContainer();

  return ReactDOM.createPortal(
    <div className={css.clsIntegrationCard}>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        uniqId="AlertModal"
        width="403px"
        padding="0"
        modalClassName={css.pricingModal}
        className={classNames(css.clsAccPageModals, css.clsBillingModal)}
      >
        <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
          <div className={classNames(css.clsModalContent, "modal-content")}>
            <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
              <div className={css.rbModalTextGroup}>
                <div className={css.rbModalTitle}>{title}</div>
                <div className={css.rbModalDetails}>{description}</div>
              </div>
              <div className={css.buttonRemoveWrapper}>
                <button className={css.confirmBtn} onClick={onClose}>
                  <span className={css.cancelRemoveLabel}>Ok</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>,
    container
  );
};

export default ShapeTooLong;